import { createFileRoute } from '@tanstack/react-router';
import { AutomationsEditorPage } from '@/features/marketing';

/** Automations editor — `/marketing/campaigns/{id}/automations` (focused screen, not nested in the hub). */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/automations')({
  component: AutomationsEditorRoute,
});

function AutomationsEditorRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <AutomationsEditorPage orgId={orgId} campaignId={campaignId} />;
}
